module.exports = __webpack_public_path__ + "static/media/marker.66406733.png";